import { render } from "./RecipeCardSkeleton.vue?vue&type=template&id=bfd0e7a8&scoped=true"
import script from "./RecipeCardSkeleton.vue?vue&type=script&lang=js"
export * from "./RecipeCardSkeleton.vue?vue&type=script&lang=js"

import "./recipeCard.css?vue&type=style&index=0&id=bfd0e7a8&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd0e7a8"]])

export default __exports__